import { MyLocation } from '@mui/icons-material';
import { Tooltip } from '@mui/material';
import { styled } from '@mui/material/styles';
import React, { useEffect, useState } from 'react';
import Colors from '../../colors';
import calculateETA from '../../utils/BingMaps';
import LoadingSpinner from '../LoadingSpinner';
import PhoneTextInput from '../PhoneTextInput';
import TextInput from '../TextInput';
import OutlineButton from './Buttons/outline/OutlinedModalButton';
import ConfirmationModal from "./ConfirmationModal";
import ModalContainer from './ModalContainer';

function EditLocation({ location, isVisible, setIsVisible, title, onSave, onDelete }) {
  const [locationName, setName] = useState("");
  const [musterPoint, setMusterPoint] = useState("");
  const [nearestHospital, setNearestHospital] = useState({ name: "", address: "" });
  const [searchAndRescue, setSearchAndRescue] = useState({ name: "Universal Emergency", phone: "911" });
  const [localGovContact, setLocalGovContact] = useState({ name: "", phone: "" });
  const [siteContact, setSiteContact] = useState({ name: "", phone: "" });
  const [deleteModal, setDelete] = useState(false);
  const [loading, setLoading] = useState(false);

  const ButtonContainer = styled('div')({
    display: 'flex',
    flexDirection: 'column',
    gap: '15px',
    alignContent: 'center',
  });

  const errMsgStyles = {
    color: 'red',
    marginTop: '-12px'
  };

  const nearestRowStyles = {
    display: 'flex',
    alignItems: 'flex-end',
    justifyContent: 'space-between',
    gap: '15px'
  };


  const [errMsg, setErrMsg] = useState();

  const handleClose = () => setErrMsg();

  const handleMissingRequirements = () => {
    if (locationName.trim().length === 0) {
      setErrMsg('Please enter name of the location.');
      return;
    }
  };

  useEffect(() => {
    if (locationName.trim().length !== 0) {
      setErrMsg();
    }
  }, [locationName])

  useEffect(() => {
    if (location) {
      setName(location.locationName || "");
      setMusterPoint(location.musterPoint || "");
      setNearestHospital({
        name: location.nearestHospital?.name || "",
        address: location.nearestHospital?.address || "",
      });
      setSearchAndRescue({
        name: location.searchAndRescue?.name || "Universal Emergency",
        phone: location.searchAndRescue?.phone || "911",
      });
      setLocalGovContact({
        name: location.localGovContact?.name || "",
        phone: location.localGovContact?.phone || "",
      });
      setSiteContact({
        name: location.siteContact?.name || "",
        phone: location.siteContact?.phone || "",
      });
    }
  }, [location])

  const handleSave = async () => {
    setLoading(true)
    const trimmedNearestHospital = {
      name: nearestHospital.name.trim(),
      address: nearestHospital.address.trim(),
    };

    const trimmedSearchAndRescue = {
      name: searchAndRescue.name.trim(),
      phone: searchAndRescue.phone.trim(),
    };
    const trimmedLocalGovContact = {
      name: localGovContact.name.trim(),
      phone: localGovContact.phone.trim(),
    };
    const trimmedsiteContact = {
      name: siteContact.name.trim(),
      phone: siteContact.phone.trim(),
    };

    const eta = await calculateETA(locationName.trim(), trimmedNearestHospital.address);
    const newLocation = {
      locationName: locationName.trim(),
      musterPoint: musterPoint.trim(),
      nearestHospital: trimmedNearestHospital,
      searchAndRescue: trimmedSearchAndRescue,
      localGovContact: trimmedLocalGovContact,
      siteContact: trimmedsiteContact,
    };
    if (location) newLocation.id = location.id
    if (eta && eta > 0) newLocation.nearestHospital.eta = eta;
    onSave(newLocation);
    setLoading(false)
    setIsVisible(false);
  };

  const handledelete = () => {
    onDelete(location)
    setDelete(false)
    setIsVisible(false)
  }

  const handleSearchNearest = (e, type) => {
    e.preventDefault();
    const location = locationName.trim() || 'me';
    const searchUrl = `https://www.google.com/maps/search/${type}+near+${encodeURIComponent(location)}`;
    window.open(searchUrl, '_blank');
  }

  return (
    <div>
      {loading && <LoadingSpinner isLoading={true} />}
      <ModalContainer
        isVisible={isVisible}
        setIsVisible={setIsVisible}
        title={title}
        onClose={handleClose}
      >
        <div style={{ width: '90%', marginBottom: '10px' }}>
          <TextInput
            label={"Name"}
            value={locationName}
            setText={setName}
          />
          <TextInput
            label={"Muster Point"}
            value={musterPoint}
            setText={setMusterPoint}
          />
          <div style={nearestRowStyles}>
            <TextInput
              label={"Nearest Hospital Name"}
              value={nearestHospital.name}
              setText={(value) =>
                setNearestHospital((prevState) => ({
                  ...prevState,
                  name: value,
                }))
              }
            />
            <Tooltip title="Search Nearest Hospitals" >
              <MyLocation sx={{ fontSize: 32, cursor: 'pointer', marginBottom: '20px' }} color='primary' onClick={(e) => handleSearchNearest(e, 'hospitals')} />
            </Tooltip>
          </div>
          <TextInput
            label={"Nearest Hospital Address"}
            value={nearestHospital.address}
            setText={(value) =>
              setNearestHospital((prevState) => ({
                ...prevState,
                address: value,
              }))
            }
          />
          <div style={nearestRowStyles}>
            <TextInput
              label={"Search and Rescue Name"}
              value={searchAndRescue.name}
              setText={(value) =>
                setSearchAndRescue((prevState) => ({
                  ...prevState,
                  name: value,
                }))
              }
            />
            <Tooltip title="Search Nearest Search And Rescues" onClick={(e) => handleSearchNearest(e, 'search+and+rescues')}>
              <MyLocation sx={{ fontSize: 32, cursor: 'pointer', marginBottom: '20px' }} color='primary' />
            </Tooltip>
          </div>
          <PhoneTextInput
            label={'Search and Rescue Phone'}
            phoneNumberText={searchAndRescue.phone}
            setPhoneNumberText={(value) =>
              setSearchAndRescue((prevState) => ({
                ...prevState,
                phone: value,
              }))} />

          <TextInput
            label={"Local Government Contact Name"}
            value={localGovContact.name}
            setText={(value) =>
              setLocalGovContact((prevState) => ({
                ...prevState,
                name: value,
              }))
            }
          />
          <PhoneTextInput
            label={'Local Government Contact Phone'}
            phoneNumberText={localGovContact.phone}
            setPhoneNumberText={(value) =>
              setLocalGovContact((prevState) => ({
                ...prevState,
                phone: value,
              }))} />

          <TextInput
            label={"Site Contact Name"}
            value={siteContact.name}
            setText={(value) =>
              setSiteContact((prevState) => ({
                ...prevState,
                name: value,
              }))
            }
          />
          <PhoneTextInput
            label={'Site Contact Phone'}
            phoneNumberText={siteContact.phone}
            setPhoneNumberText={(value) =>
              setSiteContact((prevState) => ({
                ...prevState,
                phone: value,
              }))} />
        </div>
        {errMsg && <span style={errMsgStyles}>{errMsg}</span>}
        <ButtonContainer>
          {locationName.trim().length === 0
            ? <OutlineButton
              color={Colors.mediumGray}
              label={'Save Changes'}
              onClick={handleMissingRequirements}>
            </OutlineButton>
            :
            <OutlineButton
              color={Colors.green}
              label={'Save Changes'}
              onClick={handleSave} />
          }
          {location && <OutlineButton
            color={Colors.red}
            label={'Delete'}
            onClick={() => setDelete(true)} />}
        </ButtonContainer>
        {deleteModal && <ConfirmationModal
          title={"Do you want to permanently delete this location?"}
          mainAction={"Yes"}
          isVisible={deleteModal}
          setIsVisible={setDelete}
          mainActionHandler={handledelete} />}
      </ModalContainer>
    </div>
  );
}

export default EditLocation